import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withTheme } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

const TransferDetails = ({ captionSlug, accountInfo, amount, commissionInfo, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  return (
    <div className="TransferDetails">
      <FormattedMessage id={captionSlug}>
        {txt => <span className="TransferDetails__caption">{txt}</span>}
      </FormattedMessage>
      <ul>
        <li>
          <FormattedMessage id="boAmount" />
          {amount.amount} {amount.currency}
        </li>
        <li>
          <FormattedMessage id="justEmail" />
          {accountInfo.email}
        </li>
        <li>
          <FormattedMessage id="boAccount" />
          {accountInfo.account}
        </li>
        {accountInfo.balance && (
          <li>
            <FormattedMessage id="boBalance" />
            {accountInfo.balance.amount} {accountInfo.balance.currency}
          </li>
        )}
        {accountInfo.equity && (
          <li>
            <FormattedMessage id="boEquity" />
            {accountInfo.equity.amount} {accountInfo.equity.currency}
          </li>
        )}
        {commissionInfo && commissionInfo.commissionValue && (
          <li>
            <FormattedMessage id="justCommission" />
            {commissionInfo.commissionValue.amount} {commissionInfo.commissionValue.currency}
          </li>
        )}
      </ul>
      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </div>
  );
};

TransferDetails.propTypes = {
  captionSlug: PropTypes.string.isRequired,
  accountInfo: PropTypes.object.isRequired,
  amount: PropTypes.object.isRequired,
  commissionInfo: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

TransferDetails.defaultProps = {
  theme: {},
};

export default withTheme()(TransferDetails);

export { TransferDetails };
